import './index.scss';
import React from 'react';
import { getDefaultCover } from '@/utils';

const ListBox = (props) => {
    const { live: liveCover } = getDefaultCover();

    const { id, time, coverUrl, status, title, schoolName, teacherName, gradeName, subjectName, personNumber, onClick = () => {} } = props;
    
    return (
        <div className='list-wrapper' onClick={() => { onClick(id) }}>
            <Clock className="time-duration">{time}</Clock>
            <div className="list-ppx-wrapper">
                <div className='list-cover-wrapper'>
                    <img src={coverUrl || liveCover} alt="" />
                    {
                        status === '0' && <em className="tag will">即将直播</em>
                    }
                    {
                        status === '1' && <em className="tag ing">直播中</em>
                    }
                    {
                        status === '2' && <em className="tag end">已结束</em>
                    }
                </div>
                <div className='list-info-wrapper'>
                    <p className="title">{title}</p>
                    <div className="info">
                        <span className="cut">{schoolName}</span>
                        <span className="cut">{teacherName}</span>
                    </div>
                    <div className="card">
                        { gradeName && <div className="tag defualt">{gradeName}</div> }
                        { subjectName && <div className="tag yellow">{subjectName}</div> }
                    </div>
                    { personNumber !== undefined && 
                        <div className="person-number">
                            <Personal>{personNumber}</Personal>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

const Clock = props => (
    <div className={props.className}>
        <svg
            className="clock-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ fill: 'rgb(1, 174, 250)' }}
          >
            <path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
          </svg>
        <span>{props.children}</span>
    </div>
)

const Personal = (props) => (
    <div>
        <svg className="personal-svg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13390"><path d="M708.077714 522.038857c80.768 0 150.253714-72.118857 150.253715-166.034286 0-92.781714-69.851429-161.517714-150.253715-161.517714-80.384 0-150.253714 70.235429-150.253714 162.267429 0 93.165714 69.485714 165.284571 150.253714 165.284571z m-432.365714 8.649143c69.869714 0 130.742857-63.122286 130.742857-144.64 0-80.749714-61.257143-140.489143-130.742857-140.489143-69.851429 0-131.474286 61.238857-131.090286 141.257143 0 80.749714 60.854857 143.853714 131.108572 143.853714zM66.121143 869.888h285.476571c-39.058286-56.722286 8.649143-170.916571 89.417143-233.270857-41.691429-27.794286-95.433143-48.457143-165.668571-48.457143C105.929143 588.141714 0 713.216 0 817.261714c0 33.828571 18.779429 52.608 66.102857 52.608z m405.686857 0h472.173714c58.971429 0 80.018286-16.914286 80.018286-49.974857 0-96.914286-121.344-230.637714-316.288-230.637714-194.578286 0-315.922286 133.723429-315.922286 230.656 0 33.042286 21.028571 49.956571 80.018286 49.956571z" p-id="13391"></path></svg>
        <span>{props.children}</span>人在线
    </div>
)

export default ListBox;